import React, { Component } from 'react';
import { Modal, Button, Input, Tabs } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';

const { TabPane } = Tabs;

class PreviewModal extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        pagination: {},
        activeKey: 'jinshi',
    }

    show = record => { 
        this.setState({
            data: [],
            pagination: {
                pageSize: 5,
                current: 1,
            },
            searchParam: {
                keyword: '',
                hospitalName: record.hospitalName,
                hospitalDepartmentId: record.hospitalDepartmentId,
                departmentName: record.departmentLocalName,
            },
            visible: true,
            activeKey: 'jinshi',
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { pagination, searchParam } = this.state;
        const { current, pageSize } = pagination;
        const { investigationAreaId, diseaseId, lineOfBusiness, secondLineName } = this.props.params;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryInvesByHospitalDepartmentId,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParam,
                diseaseId,
                investigationAreaId,
                lineOfBusiness,
                secondLineName,
            },
            dataType: 'json',
            doneResult: data => {
                pagination.total = data.totalCount;
                this.setState({
                    data: data.datas,
                    loading: false,
                    pagination,
                });
            }
        };
        $.sendRequest(options);
    }

    loadCompeteData = () => {
        this.setState({ loading: true });
        const { pagination, searchParam } = this.state;
        const { current, pageSize } = pagination;
        const { lineOfBusiness, secondLineName } = this.props.params;
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.queryCompetingCompanyManifestationListByHospital,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParam,
                lineOfBusiness,
                secondLineName,
            },
            dataType: 'json',
            doneResult: data => {
                pagination.total = data.totalCount;
                this.setState({
                    data: data.datas,
                    loading: false,
                    pagination,
                });
            }
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (field, e) => {
        const { searchParam } = this.state;
        searchParam[field] = e.target.value
        this.setState({ searchParam });
    }

    search = () => {
        const { activeKey } = this.state;
        if (activeKey == 'jinshi') {
            this.loadData();
        } else {
            this.loadCompeteData();
        }
    }

    export = () => {
        const { activeKey, pagination, searchParam } = this.state;
        if (activeKey == 'jinshi') {
            ExportUtil.export({ ...searchParam }, pagination, API_URL.competeCompany.exportInvesByHospitalDepartmentId);
        } else {
            ExportUtil.export({ ...searchParam }, pagination, API_URL.competeCompany.exportCompetingCompanyManifestationListByDep);
        }
    }


    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
        fixed: 'left',
    }, {
        title: 'JDE主项目号',
        dataIndex: 'investigationJdeContractCode',
        key: 'investigationJdeContractCode',
        width: 100,
        fixed: 'left',
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 120,
    },{
        title: '项目类型',
        dataIndex: 'investigationGlobalTypeStr',
        key: 'investigationGlobalTypeStr',
        width: 120,
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 100,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 90,
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 90,
    }, {
        title: '领域leader',
        dataIndex: 'leaderNameCode',
        key: 'leaderNameCode',
        width: 100,
    }, {
        title: '项目阶段',
        dataIndex: 'typeValue',
        key: 'typeValue',
        width: 90,
    }, {
        title: '递交立项资料时间',
        dataIndex: 'projectApprovalTime',
        key: 'projectApprovalTime',
        width: 120,
        render: (text) => text ? text.slice(0, 10) : '',
    }, {
        title: '启动时间',
        dataIndex: 'beginTime',
        key: 'beginTime',
        width: 90,
        render: (text) => text ? text.slice(0, 10) : '',
    }, {
        title: '启动时长(天)',
        dataIndex: 'beginDay',
        key: 'beginDay',
        width: 100,
    }, {
        title: 'open天数',
        dataIndex: 'openDay',
        key: 'openDay',
        width: 90,
    }, {
        title: '筛选病例数',
        dataIndex: 'filterAccount',
        key: 'filterAccount',
        width: 90,
    }, {
        title: '随机病例数',
        dataIndex: 'randomAccount',
        key: 'randomAccount',
        width: 90,
    }, {
        title: '入组周速率',
        dataIndex: 'weekGroupSpeed',
        key: 'weekGroupSpeed',
        width: 90,
    }, {
        title: '入组月速率',
        dataIndex: 'monthGroupSpeed',
        key: 'monthGroupSpeed',
        width: 90,
    }, {
        title: '研究中心项目阶段',
        dataIndex: 'siteStageNames',
        key: 'siteStageNames',
        width: 100,
    }, {
        title: '中心合同计划单访视工时折算系数',
        dataIndex: 'visitHourConversionFactor',
        key: 'visitHourConversionFactor',
        width: 120,
    }, {
        title: 'PM',
        dataIndex: 'pmUserCompellation',
        key: 'pmUserCompellation',
        width: 90,
    }, {
        title: 'PI',
        dataIndex: 'piName',
        key: 'piName',
        render: (text, record) => {  
            return (
                <span> 
                    {record.postStatus=="OFF"?                   
                    <p>{record.piName}(转岗)</p>
                    :
                    <p>{record.piName}</p>
                    }
                </span>
            );
        },
        width: 90,
    }, {
        title: 'CRC',
        dataIndex: 'crcName',
        key: 'crcName',
        width: 90,
    }]

    getCompeteColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
        fixed: 'left',
    }, {
        title: '公司名称',
        dataIndex: 'companyName',
        key: 'companyName',
        width: 120,
        fixed: 'left',
    }, {
        title: 'JDE主项目号',
        dataIndex: 'investigationJdeContractCode',
        key: 'investigationJdeContractCode',
        width: 100,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 120,
    }, {
        title: '项目类型',
        dataIndex: 'investigationGlobalTypeStr',
        key: 'investigationGlobalTypeStr',
        width: 120,
    },{
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 100,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    },, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 90,
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 90,
    }, {
        title: '领域leader',
        dataIndex: 'leaderNameCode',
        key: 'leaderNameCode',
        width: 100,
    }, {
        title: '项目阶段',
        dataIndex: 'typeValue',
        key: 'typeValue',
        width: 90,
    }, {
        title: '递交立项资料时间',
        dataIndex: 'projectApprovalTime',
        key: 'projectApprovalTime',
        width: 120,
        render: (text) => text ? text.slice(0, 10) : '',
    }, {
        title: '启动时间',
        dataIndex: 'beginTime',
        key: 'beginTime',
        width: 90,
        render: (text) => text ? text.slice(0, 10) : '',
    }, {
        title: '启动时长(天)',
        dataIndex: 'beginDay',
        key: 'beginDay',
        width: 100,
    }, {
        title: 'open天数',
        dataIndex: 'openDay',
        key: 'openDay',
        width: 90,
    }, {
        title: '筛选病例数',
        dataIndex: 'filterOutNumber',
        key: 'filterOutNumber',
        width: 90,
    }, {
        title: '随机病例数',
        dataIndex: 'groupNumber',
        key: 'groupNumber',
        width: 90,
    }, {
        title: '入组周速率',
        dataIndex: 'weekGroupSpeed',
        key: 'weekGroupSpeed',
        width: 90,
    }, {
        title: '入组月速率',
        dataIndex: 'monthGroupSpeed',
        key: 'monthGroupSpeed',
        width: 90,
    }, {
        title: '研究中心项目阶段',
        dataIndex: 'siteStageNames',
        key: 'siteStageNames',
        width: 100,
    }, {
        title: '项目合同计划单访视工时折算系数',
        dataIndex: '项目合同计划单访视工时折算系数',
        key: '项目合同计划单访视工时折算系数',
        width: 120,
    },]

    getDataSource = () => {
        const dataSource = [];
        const { data = [], pagination } = this.state;
        const { current, pageSize } = pagination;
        data.map((item, index) => {
            dataSource.push({
                index: (current - 1) * pageSize + index + 1,
                ...item,
            });
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.search();
        });
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            data: [],
            activeKey,
            pagination: {
                pageSize: 5,
                current: 1,
            },
        }, () => {
            this.search();
        });
    }


    render() {
        const { visible, loading, data, activeKey, pagination, searchParam = {} } = this.state;
        const { keyword, hospitalName, departmentName } = searchParam;
        return (
            <Modal
                title="项目明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="1140px"
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="primary-tabs-active" style={{ background:'#fff', padding:'10px 30px' }}>
                    <div className="filter-bar">
                        <div className="filter-bar-investigation" style={{width:'100%'}}>
                            <h3 style={{float:'left'}}>医院名称：{hospitalName} <span className="ant-divider" /> 科室：{departmentName}</h3>
                        </div>
                        <div className="filter-bar-investigation" style={{width:'100%'}}>
                            <div className="form-item" style={{float:'right'}}>
                                <label htmlFor="" className="ui-label">项目编号 / 项目简称</label>
                                <Input
                                    placeholder="请输入项目编号"
                                    onChange={this.handleChange.bind(this, 'keyword')}
                                    onKeyPress={this.enterSearch}
                                    value={keyword}
                                />
                                <Button
                                    type="primary"
                                    onClick={this.export}
                                >导出</Button>
                                <Button
                                    type="primary"
                                    icon="search"
                                    onClick={
                                        () => {
                                            this.setState(prevState => ({
                                                pagination: {
                                                    ...prevState.pagination,
                                                    current: 1,
                                                }
                                            }), () => {
                                                this.search();
                                            });
                                        }
                                    }
                                >搜索</Button>
                            </div>
                            
                        </div>
                    </div>
                    <Tabs onChange={this.handleTabsChange} type="card" activeKey={activeKey}>
                        <TabPane tab="津石表现" key="jinshi">
                            <TableC
                                columns={this.getColumns()}
                                data={data}
                                loading={loading}
                                onChange={this.handleTableChange}
                                scrollY={400}
                                className="jinshi"
                                pagination={pagination}
                            />
                        </TabPane>
                        <TabPane tab="竞争公司表现" key="compete">
                            <TableC
                                columns={this.getCompeteColumns()}
                                data={data}
                                loading={loading}
                                onChange={this.handleTableChange}
                                scrollY={400}
                                className="compete"
                                pagination={pagination}
                            />
                        </TabPane>
                    </Tabs>
                </div>
            </Modal>
        );
    }
}

export default PreviewModal;


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/PreviewModal.js